// extracted by mini-css-extract-plugin
export default {"cls1":"VeloOverlay-Overlay_cls1__YriLa","cls2":"VeloOverlay-Overlay_cls2__f5V-Z VeloOverlay-Overlay_cls1__YriLa","transparent":"VeloOverlay-Overlay_transparent__yZ4V8"};